###
Product unit pricing service controls data needed to show base unit price, e.g. 5 EUR / 1 kg

Product has 4 possible unit attributes:
- product_data.unit_id - unit type to sell as. Always set, even if unit pricing is disabled
- unit_id_base - base unit for which to calculate unit price
- unit_amount - if product is sold as pc, it can have some pre-set amount. E.g.
		there may be a bag of candy of 400 g, sold as 1 pc for 2 EUR, but it still
		must show base price of 5 EUR / 1 kg
- unit_id_actual - if product is sold as pc, unit type for unit_amount

If product has variants, unit_amount and unit_id_actual should be set on variants
instead of product
###
class ProductUnitDataModalService extends BaseService
	@register angular.module 'App.Service'

	constructor: (@translate, @product, @productUnitId, @productAttributesService, @newVariant, @units, @setUnitDataProperties) ->
		super()

		@enableProductActualUnitData = false
		@productInfoMessage = null
		@unitsBase = []
		@unitsActual = []

		# A separate unit for "not set" is needed to allow deleting value by selecting this in a <select> input
		@unitNotSet =
			'id': '-1'
			'default': '0'
			'name': '-- ' + @translate('wbo.not.set') + ' --'
			'base_unit': null
			'base_unit_multiplier': null

	initializeUnitData: ->
		# Copying data to allow to cancel changes by closing modal
		@unitForSaleId = @productUnitId
		@unitBaseId = @productAttributesService.attributes.unit_id_base?.value
		@unitActualId = @productAttributesService.attributes.unit_id_actual?.value
		@unitAmount = @productAttributesService.attributes.unit_amount?.value

		@enableVariantsActualUnitData = false
		@variantUnitDataInfoMessage = null
		@productVariantActualUnits = []

	handleDataChanges: ->
		if _.isEmpty @unitBaseId
			@unitBaseId = @unitNotSet.id

		unitForSale = @getUnitObjectById @unitForSaleId
		unitBase = @getUnitObjectById @unitBaseId

		if unitForSale.id != 'pc' && unitForSale.base_unit != unitBase.base_unit
			# Unit group has changed (e.g. from kg to m)

			if unitBase.id != @unitNotSet.id
				# On unit group change modify base unit only if it was already set, so that
				# it would remain valid. If it was not set, we leave it as not set
				unitBase = @getUnitObjectById unitForSale.base_unit

		@unitBaseId = unitBase.id
		@enableProductActualUnitData = @product.product_variants.length == 0 && unitForSale.id == 'pc' && unitBase.id != @unitNotSet.id
		@refreshAllowedBaseUnits(unitForSale)
		@refreshAllowedActualUnits(unitBase)

		if !@enableProductActualUnitData
			# Unit data has very complex logic to enabled/disable some of the fields, so
			# we show additional info messages to make it more understandable to the user
			if unitForSale.id != 'pc'
				@productInfoMessage = 'wbo.product.unit.info_message.product.select_pc_unit_for_sale'
			else if unitBase.id == @unitNotSet.id
				@productInfoMessage = 'wbo.product.unit.info_message.product.select_base_unit'
			else if @product.product_variants.length != 0
				@productInfoMessage = 'wbo.product.unit.info_message.product.set_on_variant'

			return

		@productInfoMessage = null

		if !_.isEmpty @unitActualId
			unitActual = @getUnitObjectById @unitActualId
		else
			unitActual = null

		if unitActual == null || unitActual.base_unit != unitBase.base_unit
			# Unit group has changed (e.g. from kg to m) (or actualUnit was never set)
			# so we set it to the same as base unit
			unitActual = @getUnitObjectById unitBase.id

		@unitActualId = unitActual?.id

	persistData: ->
		@persistProductData()
		@persistAllVariantsData()

		@setUnitDataProperties(@unitForSaleId, @enableVariantsActualUnitData, @productVariantActualUnits, @variantUnitDataInfoMessage)

	persistProductData: ->
		@productUnitId = @unitForSaleId

		if @unitBaseId != @unitNotSet.id
			@productAttributesService.setAttribute 'unit_id_base', @unitBaseId
		else
			@productAttributesService.removeAttribute 'unit_id_base'

		if @product.product_variants.length || @unitForSaleId != 'pc' || @unitBaseId == @unitNotSet.id || @unitAmount == 0
			@productAttributesService.removeAttribute 'unit_id_actual'
			@productAttributesService.removeAttribute 'unit_amount'

			return

		@productAttributesService.setAttribute 'unit_id_actual', @unitActualId
		@productAttributesService.setAttribute 'unit_amount', @unitAmount

	persistAllVariantsData: ->
		unitBase = @getUnitObjectById @unitBaseId

		if @unitForSaleId != 'pc' || @unitBaseId == @unitNotSet.id
			@enableVariantsActualUnitData = false
			@productVariantActualUnits = []
			@variantUnitDataInfoMessage = 'wbo.product.unit.info_message.variant.set_main_product_unit_data'

			return

		@enableVariantsActualUnitData = true
		@productVariantActualUnits = _.filter @units, {base_unit: unitBase.base_unit}
		@variantUnitDataInfoMessage = null

		@persistOneVariantData @newVariant, unitBase

		for variant in @product.product_variants
			@persistOneVariantData variant, unitBase

	persistOneVariantData: (variant, unitBase) ->
		if !_.isEmpty variant.attributeService.attributes.unit_id_actual?.value
			unitActual = @getUnitObjectById variant.attributeService.attributes.unit_id_actual.value
		else
			unitActual = null

		if unitActual == null || unitActual.base_unit != unitBase.base_unit
			unitActual = @getUnitObjectById unitBase.id

		variant.attributeService.setAttribute 'unit_id_actual', unitActual.id

	getUnitObjectById: (unitId) ->
		if unitId == @unitNotSet.id
			return @unitNotSet

		return _.find @units, {id: unitId}

	refreshAllowedBaseUnits: (unitForSale) ->
		if unitForSale.id == 'pc'
			@unitsBase = _.reject @units, {id: 'pc'}
		else
			@unitsBase = _.filter @units, {base_unit: unitForSale.base_unit}

		@unitsBase.unshift @unitNotSet

	refreshAllowedActualUnits: (unitBase) ->
		if unitBase.id == @unitNotSet.id
			@unitsActual = []

			return

		@unitsActual = _.filter @units, {base_unit: unitBase.base_unit}
